import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerIndicador = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Indicador/ObtenerIndicadoresExigenciasPorAreaNegocio",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerIndicador };
